<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `transaction/placement/${inputs.id}`
            : `transaction/placement`
        "
      >
        <div class="form-group row align-items-center" >
          <label for="inputs_booked_date" class="col-sm-3 mb-0">
            Booked Date
          </label>
          <app-input
            id="inputs_booked_date"
            class="col-sm-9"
            type="date"
            v-model="inputs.booked_date"
            placeholder="Booked Date"
            required
          />
        </div>
        <!-- Booked Time -->
        <div class="form-group row align-items-center" >
          <label for="inputs_booked_time" class="col-sm-3 mb-0">
            Booked Time
          </label>
          <app-input
            id="inputs_booked_time"
            class="col-sm-9"
            type="time"
            :is-enable-minute="false"
            v-model="inputs.booked_time"
            placeholder="Booked Time"
            required
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_notes" class="col-sm-3 mb-0"> Notes </label>
          <app-input
            id="inputs_notes"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.notes"
            :placeholder="'Notes'"
            required
          />
        </div>
        <!-- Class -->
        <!-- <div class="form-group row align-items-center">
					<label for="inputs_class_id" class="col-sm-3 mb-0">
						Class
					</label>
					<app-input
						id="inputs_class_id"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.class_id"
						placeholder="Class"
						:list="classLists"
						required
					/>
				</div> -->
      </form>
    </template>
  </modal>
</template>

<script>
import { PlacementBookingFormMixin } from "./PlacementBookingFormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";
import { UserMixin } from "../../../../../Auth/Mixins/UserMixin";

export default {
  name: "PlacementBookingRescheduleTableForm",
  mixins: [PlacementBookingFormMixin, ModalMixin, UserMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      preloader: false,
      inputs: {
        clc_id_number: this.value.clc_id_number,
      }, 
      modalId: this.formId,
      modalTitle: 'Reschedule',
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = 'Reschedule';
      this.preloader = true;
    } 
  },
  methods: {
    submit() {
        this.inputs.status_reschedule = 1;
        this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
      this.inputs = {};
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;

      this.inputs.booked_time = response.data.booked_time.slice(0, -3);

      this.preloader = false;
    },

  },
};
</script>
